import { IAccessor } from 'interfaces';
import { BaseService } from './BaseService';

class AccessorService extends BaseService<IAccessor> {
  constructor() {
    super('accessories');
  }
  canDelete = true;
  canBulkDelete = true;
}

export const accessorService = new AccessorService();
